import { Injectable } from '@angular/core';
import { BehaviorSubject, forkJoin, take } from 'rxjs';
import { UserRolesEnum } from '../common/enums/user-roles-enum';
import { ClinicListItem } from '../common/models/users-data/clinic-list-item.model';
import { CreateUserItem } from '../common/models/users-data/create-user-item.model';
import { EditUserItem } from '../common/models/users-data/edit-user-item.model';
import { EditUserPropertiesItem } from '../common/models/users-data/edit-user-properties-item.model';
import { EntOfficeListItem } from '../common/models/users-data/ent-office-list-item.model';
import { UserListItem } from '../common/models/users-data/user-list-item.model';
import { RequestsService } from './requests.service';
import { UserListService } from './user-list.service';
import { UserRightRolesEnum } from '../common/enums/user-right-roles-enum';

@Injectable({
  providedIn: 'root'
})
export class UserManageService
{

  currentUser: UserListItem | undefined
  editedUser: EditUserItem | undefined
  newUserClinicList: string[] = []
  newUserClinicListUpdatedSubject = new BehaviorSubject<boolean>(false)

  currentClinic: ClinicListItem | undefined
  currentOffice: EntOfficeListItem | undefined

  constructor(private requestsService: RequestsService, private userListService: UserListService) { }

  createUser()
  {
    if (this.currentUser && this.currentUser.firstName && this.currentUser.lastName && this.currentUser.email && this.currentUser.role && this.currentUser.countryId && this.currentUser.lang && (this.currentUser.clinicId || this.currentUser.entOfficeId || this.currentUser.role == UserRolesEnum.dal))
    {
      let l_newUser: CreateUserItem = {
        name: this.currentUser.firstName!,
        lastName: this.currentUser.lastName!,
        email: this.currentUser.email!,
        role: this.currentUser.role!,
        country: this.currentUser.countryId!.toLowerCase(),
        language: this.currentUser.lang!,
        shopId: this.currentUser.clinicId ? this.currentUser.clinicId! : "undefined",
        entOfficeId: this.currentUser.entOfficeId ? this.currentUser.entOfficeId! : undefined,
        extendedRoles:this.getAccessRole(this.currentUser.shopAdminAccess,this.currentUser.countryShopsAccess,this.currentUser.patientManagerAccess,this.currentUser.advancedMode)

      }

      this.requestsService.createUser(l_newUser).pipe(take(1)).subscribe(l_user =>
      {
        if (this.newUserClinicList.length > 0)
        {
          this.requestsService.setClinicList(l_user.id, this.newUserClinicList).pipe(take(1)).subscribe(() =>
          {
            this.requestsService.sendInvitation(l_user.id).pipe(take(1)).subscribe(() =>
            {
              this.clearUser();
              this.userListService.needsToRefresh.next(true);
            })
          })
        } else
        {
          this.requestsService.sendInvitation(l_user.id).pipe(take(1)).subscribe(() =>
          {
            this.clearUser();
            this.userListService.needsToRefresh.next(true);
          })
        }

      })
    }
  }

  deleteUser()
  {

    if (this.currentUser)
    {
      let l_userId = this.currentUser.userId;

      this.requestsService.deleteUser(l_userId).pipe(take(1)).subscribe(() =>
      {

        this.clearUser();
        setTimeout(() =>
        {
          this.userListService.needsToRefresh.next(true)
        }, 1000);
      })
    }
  }

  resetUserPassword()
  {

    if (this.currentUser)
    {
      let l_userId = this.currentUser.userId;

      this.requestsService.resetUserPassword(l_userId).pipe(take(1)).subscribe(() =>
      {

        this.clearUser();
        setTimeout(() =>
        {
          this.userListService.needsToRefresh.next(true)
        }, 1000);
      })
    }
  }

  editUser()
  {
    console.log(this.editedUser)
    if (this.editedUser && this.currentUser)
    {
      let l_edit: EditUserPropertiesItem = {
        GivenName: (this.editedUser.properties.firstName !== this.currentUser?.firstName) ? this.editedUser.properties.firstName : undefined,
        Surname: (this.editedUser.properties.lastName !== this.currentUser?.lastName) ? this.editedUser.properties.lastName : undefined,
        Language: (this.editedUser.properties.lang !== this.currentUser?.lang) ? this.editedUser.properties.lang! : undefined,
        ShopId: this.editedUser.properties.clinicId !== this.currentUser?.clinicId ? this.editedUser.properties.clinicId : undefined,
        ENTOfficeId: this.editedUser.properties.entOfficeId !== this.currentUser?.entOfficeId ? this.editedUser.properties.entOfficeId : undefined,
        ExtendedRoles:  (this.editedUser.properties.shopAdminAccess !== this.currentUser?.shopAdminAccess)||
                        (this.editedUser.properties.countryShopsAccess !== this.currentUser?.countryShopsAccess)||
                        (this.editedUser.properties.patientManagerAccess !== this.currentUser?.patientManagerAccess) ||
                        (this.editedUser.properties.advancedMode !== this.currentUser?.advancedMode) ? 
                        this.getAccessRole(this.editedUser.properties.shopAdminAccess,this.editedUser.properties.countryShopsAccess,this.editedUser.properties.patientManagerAccess,this.editedUser.properties.advancedMode) : undefined,
      }



      if (this.newUserClinicList.length > 0)
      {
        forkJoin({
          clinicList: this.requestsService.setClinicList(this.editedUser.userId, this.newUserClinicList).pipe(take(1)),
          editUser: this.requestsService.editUser(this.editedUser.userId, l_edit).pipe(take(1))
        }).subscribe(() =>
        {

          this.clearUser()
          this.userListService.needsToRefresh.next(true)
        })

      } else
      {
        this.requestsService.editUser(this.editedUser.userId, l_edit).subscribe(() =>
        {
          this.clearUser()
          this.userListService.needsToRefresh.next(true)
        })
      }
    }
  }

  getAccessRole(shopAdminAccess: boolean,countryShopsAccess:boolean,patientManagerAccess:boolean,advancedMode:boolean)
  {
    let l_roles=[]
    if (shopAdminAccess) l_roles.push(UserRightRolesEnum.ShopAdmin)
    if (countryShopsAccess) l_roles.push(UserRightRolesEnum.CountryManager)
    if (patientManagerAccess) l_roles.push(UserRightRolesEnum.PatientManager)
    if (advancedMode) l_roles.push(UserRightRolesEnum.AdvancedMode)
    return l_roles.join(',')
  }

  changeUserStatus(userid: string, accountEnabled: boolean)
  {
    this.requestsService.changeUserStatus(userid, accountEnabled).pipe(take(1)).subscribe(() =>
    {
      console.log("User status changed succesfully")
      this.userListService.needsToRefresh.next(true)
    })
  }

  clearUser()
  {
    this.currentUser = undefined
    this.currentClinic = undefined
    this.currentOffice = undefined
    this.editedUser = undefined
    this.newUserClinicList = [];
    this.newUserClinicListUpdatedSubject.next(false);
  }
}
